(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["page-cart-subtotal"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const klarnaPlacement = this.querySelector('klarna-placement');
    if (! klarnaPlacement) return;
    

    const locale = getLocale();
    klarnaPlacement.setAttribute('data-locale', locale);
  });

  } catch(e) { console.error(e); }
})();
})();
